import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiQaroniEnv } from '@qaroni-core/conf/apis/api-qaroni.config';
import { BankApiObject } from '../types/bank.response';

@Injectable({
  providedIn: 'root',
})
export class BankHttpService {
  private http = inject(HttpClient);

  public banks$() {
    const url = `${ApiQaroniEnv.URLBase}/admin/banks`;

    return this.http.get<BankApiObject>(url);
  }
}
